module.exports = __webpack_public_path__ + "static/SandcastleMoving-a7f3a8593ad7c22eacc7d6ccb83b454a.gif";